const TWILIO_CONVERSATION_ID = /^CH[0-9a-fA-F]{32}$/;

/**
 * Whether a conversation id names a Twilio conversation, which is always an
 * inquiry, rather than a native conversation served by the API, whose id is
 * uuid text.
 *
 * The id's format is the server's contract for telling the two apart, so the
 * app routes on it without a request. Both kinds share one chat deep link.
 */
export function isTwilioConversationId(id: string | null | undefined): id is string {
  return typeof id === 'string' && TWILIO_CONVERSATION_ID.test(id);
}
